import { useEffect, useRef, useState, useCallback } from 'react';
import DailySafetyReport from './NewPDF';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import AreaService from '../../../../../api/areaService';
import { area_shift_wise_alert_report, area_wise_alert_report, complianceAnalysisSubArea, executive_summary_for_report, get_alerts_for_report, get_shift_based_report, moduleAnalysis, shiftAnalysis, shiftComparison } from '../../../../../RenderPDFformat/utils/reportApiUtils';
import { toast } from 'react-toastify';
import Loader1 from '../../../../../CommonElements/Spinner/loader';
import * as XLSX from 'xlsx'; // Import xlsx
import { BsFiletypePdf } from "react-icons/bs";
import { errorToast } from '../../../../../_helper/helper';
import { validateFilters } from '../../../../../utils/formatDate'

const PdfRenderer = ({ onDone, filters, callApi }) => {
  const hasRunRef = useRef(false);
  const timerRef = useRef(null);
  const componentRef = useRef(null);
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [loader, setLoader] = useState(false);

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [file, setFile] = useState(null);

  // State for storing parsed Excel data
  // const [excelData, setExcelData] = useState({});
  const [shenetType, setShenetType] = useState('');

  // Callback to handle modal file input
  // const handleFileChange = (event) => {
  //   const uploadedFile = event.target.files[0];
  //   setFile(uploadedFile);

  //   // Parse the Excel file
  //   if (uploadedFile) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const data = e.target.result;
  //       const workbook = XLSX.read(data, { type: 'binary' });

  //       // Assuming the first sheet is the one we want
  //       const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

  //       // Convert the sheet to JSON
  //       const sheetData = XLSX.utils.sheet_to_json(firstSheet);

  //       // Map the sheetData to an object with column names as keys
  //       const formattedData = sheetData.reduce((acc, row) => {
  //         Object.keys(row).forEach((column) => {
  //           if (!acc[column]) {
  //             acc[column] = [];
  //           }
  //           acc[column].push(row[column]);
  //         });
  //         return acc;
  //       }, {});

  //       if (formattedData.Category) {
  //         const uniqueCategories = [...new Set(formattedData.Category)];
  //         console.log(uniqueCategories); // This will log only unique values
  //         setApiData((prev) => ({
  //           ...prev,
  //           pyramidCategories: uniqueCategories
  //         }))
  //       }

  //       console.log('display excel data', formattedData)

  //       setExcelData(formattedData);
  //       toast.success('Excel file parsed successfully');
  //     };
  //     reader.readAsBinaryString(uploadedFile);
  //   }
  // };

  // Function to handle PDF generation (existing)
  const handlePdfDone = useCallback(() => {
    setGeneratingPDF(false);
  }, []);

  const getPdf = async () => {
    try {
      const firstPageElement = componentRef.current;
      if (!firstPageElement) return;

      // Temporarily disable ApexCharts animations
      const charts = firstPageElement.querySelectorAll('.apexcharts-canvas');
      charts.forEach(chart => {
        const chartInstance = window.ApexCharts.getChartByID(chart.id);
        if (chartInstance) {
          chartInstance.updateOptions({
            chart: { animations: { enabled: false } }
          }, false, false);
        }
      });

      // Wait for charts to stabilize
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Render DOM to canvas
      const firstCanvas = await html2canvas(firstPageElement, {
        scale: 1.5, // reduce scale for lighter file
        useCORS: true,
        allowTaint: true,
        scrollY: -window.scrollY,
        logging: false,
        onclone: (document) => {
          const clonedCharts = document.querySelectorAll('.apexcharts-canvas');
          clonedCharts.forEach(chart => {
            chart.style.visibility = 'visible';
            chart.style.position = 'static';
          });
        }
      });

      // Convert canvas to compressed JPEG
      const firstImgData = firstCanvas.toDataURL("image/jpeg", 0.6); // compressed JPG

      // Keep dynamic page size (same as your original logic)
      const pdfWidth = 230;
      const canvasWidth = firstCanvas.width;
      const canvasHeight = firstCanvas.height;
      const pdfHeight = (canvasHeight * pdfWidth) / canvasWidth;

      // Create PDF with custom height (so no splitting)
      const pdf = new jsPDF("p", "mm", [pdfHeight, pdfWidth]);
      pdf.addImage(firstImgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${filters?.week ? 'Weekly' : filters?.month ? 'Monthly' : 'Daily'}Report.pdf`);

      // Re-enable animations after PDF generation
      charts.forEach(chart => {
        const chartInstance = window.ApexCharts.getChartByID(chart.id);
        if (chartInstance) {
          chartInstance.updateOptions({
            chart: { animations: { enabled: true } }
          }, false, false);
        }
      });
      setLoader(false)
      toast.success('PDF downloaded successfully');
    } catch (error) {
      toast.error('Error generating PDF');
      console.error('Error generating PDF:', error);
    }
  };


  function downloadPdf() {
    if (file==null || shenetType==''){
      return toast.error('Insert Shenet Data')
    }
   const validate = validateFilters(filters) 
    if (!validate) {
      return ;
    }
    setLoader(true)
    const checking_filters = validateFilters(filters, true)
   
    if (checking_filters) {
      if (generatingPDF) return;
      setGeneratingPDF(true);

      toast.info('PDF Downloading');

      timerRef.current = setTimeout(async () => {
        await getPdf();

        setGeneratingPDF(false); // Reset
      }, 500);
    }


  }

  

  const factoryID = JSON.parse(localStorage.getItem('userData')).factory.id;
  const userID = JSON.parse(localStorage.getItem('userData')).id;

  const [apiData, setApiData] = useState({
    executiveSummary: {
      totalAlerts: 0,
      avgCompliance: 0,
      peakAlerts: 0,
      highRiskArea: ''
    },
    shiftBased: {},
    shiftComparison: [],
    alertsChartsData: {},
    pyramidCategories: [],
    areaWiseChart: [],
    areaShiftWise: [],
    moduleAnalysis: [],
    complianceSubArea: [],
    shiftAnalysis: []
  });

  const [renderpage, setrenderpage] = useState(false)

  const allApisForReportData = () => {
    setLoader(true);
    Promise.all([
      executive_summary_for_report(userID, factoryID, filters),
      get_alerts_for_report(userID, factoryID, filters),
      // get_shift_based_report(userID, factoryID, filters),
      area_wise_alert_report(userID, factoryID, filters),
      // area_shift_wise_alert_report(userID, factoryID, filters),
      shiftComparison(userID, factoryID, filters),
      moduleAnalysis(userID, factoryID, filters),
      complianceAnalysisSubArea(userID, factoryID, filters),
      shiftAnalysis(userID, factoryID, filters),
    ]).then(([execData, alertsChartData,  areaWise, shiftComparisonn, moduleAnalysiss, complianceSubAreaa, shiftAnalysiss]) => {

      setApiData((prev) => ({
        ...prev,
        executiveSummary: {
          totalAlerts: execData.total_alerts,
          peakAlerts: execData.peak_alert_time,
          avgCompliance: execData.site_compliance,
          highRiskArea: execData.high_risk_area,

        },

        alertsChartsData: alertsChartData,
       
        areaWiseChart: areaWise,
        shiftComparison: shiftComparisonn,
        moduleAnalysis: moduleAnalysiss,
        complianceSubArea: complianceSubAreaa,
        shiftAnalysis: shiftAnalysiss
      }));
      setrenderpage(true)
      setLoader(false);
    });
  }
  useEffect(() => {
    console.log("-------------------xd----------------")
    console.log(filters)
    const checking_filters = validateFilters(filters, false)
    if (checking_filters) {
      allApisForReportData()
    }
    else {
      setLoader(false)
    }
  }, [callApi && filters]);

   const [file, setFile] = useState(null);
  const [excelData, setExcelData] = useState({});
  const [MOCData, setMOCData] = useState({
    ticketCards: {

    
    closure_rate: 0,
    open_tickets: 0,
    over_due_tickets: 0, // You can calculate this later
    },
    ticketsAnalysis: {
      categories: [],
      series: []
    },
    comparisonChart: {
      categories: [],
      series: []
    },
    ticketItems: []
  });

  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    setFile(uploadedFile);

    // Parse the Excel file
    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // Assuming the first sheet is the one we want
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

        // Convert the sheet to JSON
        const sheetData = XLSX.utils.sheet_to_json(firstSheet);

        // Process the data
        processExcelData(sheetData);

        toast.success("Excel file parsed successfully");
      };
      reader.readAsBinaryString(uploadedFile);
    }
  };

  // Function to process the Excel data
const processExcelData = (sheetData) => {
  console.log('sheetdata', sheetData);
  
  // Start from the 3rd index in the array (since the first few rows are header/metadata)
  const filteredRows = sheetData.slice(3);  // Skip first 3 rows

  // Count rows where __EMPTY_9 (Status column) is non-empty
  const nonEmptyStatusRows = filteredRows.filter((row) => row["__EMPTY_9"] && row["__EMPTY_9"].trim() !== "").length;

  // Count rows where __EMPTY_9 (Status column) has "Closed"
  const closedRows = filteredRows.filter((row) => row["__EMPTY_9"] === "Closed").length;

  // Calculate closure rate and round to 1 decimal place
  const closureRate = (nonEmptyStatusRows === 0) ? 0 : parseFloat(((closedRows / nonEmptyStatusRows) * 100).toFixed(1));

  // Calculate open tickets (non-empty status rows - closed rows)
  const openTickets = nonEmptyStatusRows - closedRows;

  // Calculate overdue tickets
  const currentDate = new Date();  // Get the current date
  const overdueTickets = filteredRows.filter((row) => {
    const targetCompletionDate = row["__EMPTY_7"];  // Get the Target Completion date
    if (targetCompletionDate) {
      const targetDate = new Date(targetCompletionDate);  // Convert string to Date object
      return currentDate > targetDate;  // Compare with current date
    }
    return false;
  }).length;

  const allNames = filteredRows
  .map((row) => row["__EMPTY_10"])  // Get all values from __EMPTY_10 column
  .filter((value) => value)  // Remove undefined or null values
  .flatMap((names) => names.split(";"))  // Split by ';' to get individual names
  .map((name) => name.trim())  // Remove extra spaces
  .filter((name, index, self) => self.indexOf(name) === index);  // Ensure uniqueness

// Count how many times each name appears in __EMPTY_10 (nameCounts)
const nameCounts = allNames.map((name) => {
  return filteredRows.filter((row) => row["__EMPTY_10"] && row["__EMPTY_10"].includes(name)).length;
});

// Count how many times each name has "Closed" in __EMPTY_9 (closedData)


// For each name, calculate Due and Overdue counts
const dueData = allNames.map((name) => {
  return filteredRows.filter((row) => {
    const nameMatches = row["__EMPTY_10"] && row["__EMPTY_10"].includes(name);
    const targetDateStr = row["__EMPTY_7"];
    if (nameMatches && targetDateStr) {
      const targetDate = new Date(targetDateStr);
      return targetDate >= currentDate;  // Due tickets
    }
    return false;
  }).length;
});

const overdueData = allNames.map((name) => {
  return filteredRows.filter((row) => {
    const nameMatches = row["__EMPTY_10"] && row["__EMPTY_10"].includes(name);
    const targetDateStr = row["__EMPTY_7"];
    if (nameMatches && targetDateStr) {
      const targetDate = new Date(targetDateStr);
      return targetDate < currentDate;  // Overdue tickets
    }
    return false;
  }).length;
});

// Prepare the series for comparisonChart
const comparisonSeries = [
  {
    name: "Due",
    data: dueData,
  },
  {
    name: "Overdue",
    data: overdueData,
  },
];

// Prepare the series data
const seriesData = [
  {
    name: "Open Actions",
    data: nameCounts,  // Use the counts of each name as the data for the series
  },
];




const ticketItemDetails = filteredRows.map((item) => {
  const targetDateStr = item['__EMPTY_7'];
  let remarks = 'Due';  // Default

  // If status is Closed, override remarks
  if (item['__EMPTY_9'] === 'Closed') {
    remarks = 'Closed';
  } else if (targetDateStr) {
    const targetDate = new Date(targetDateStr);
    if (targetDate < currentDate) {
      remarks = 'Overdue';
    }
  }

  return {
    ticket_no: item['__EMPTY'],
    source_category: item['__EMPTY_11'],
    source: item['__EMPTY_11'],
    status: item['__EMPTY_9'],
    person_resp: item['__EMPTY_10'],
    due_date: targetDateStr,
    remarks: remarks,
  };
});





  // Update state with calculated values in ticketCards and categories in ticketsAnalysis
  setMOCData((prevState) => ({
    ...prevState,
    ticketCards: {
      closure_rate: closureRate,
      open_tickets: openTickets,
      over_due_tickets: overdueTickets,
    },
    ticketsAnalysis: {
      categories: allNames,  // Store the unique names in categories
      series: seriesData,  // You can update this later as needed
    },
    comparisonChart: {
      categories: allNames,
      series: comparisonSeries
    },
    ticketItems: ticketItemDetails
  }));

  console.log('MOC closed tickets', closedRows);
  console.log('MOC overdue tickets', overdueTickets);  // Log overdue tickets count
  console.log('Unique names in categories:', allNames);  // Log the unique names in categories
  setExcelData(sheetData);  // Store raw data if needed
};





  return (
    <>
      {
        generatingPDF && (
          <div
            ref={componentRef}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '1000px',
              pointerEvents: 'none',
              zIndex: -9999,
              background: 'white'
            }}
          >
            <DailySafetyReport MOCData={MOCData} apiData={apiData} isPdfRendering={true} filters={filters} />
          </div>
         )
       }  
            {/* <DailySafetyReport apiData={apiData} isPdfRendering={true} filters={filters} /> */}


      <button
        className="d-flex align-items-center justify-content-center ms-2 rounded-2 gap-2 bg-danger border-0 px-3 py-2"
        style={{ fontFamily: 'Poppins' }}
        disabled={loader ? true : false}
        onClick={() => setIsModalOpen(true)} // Open the modal

        // onClick={downloadPdf}

      >
        {loader ? (
          <div className="spinner-border spinner-border-sm text-white" role="status"></div>
        ) : (
          <>
            <BsFiletypePdf style={{ fontSize: '22px' }} />
            <p className='p-0 m-0'>{filters.week ? 'Weekly' : filters.date ? 'Daily' : filters.month && 'Monthly'} Report</p>
          </>
        )}
      </button>

      {/* Modal for file upload */}
    {isModalOpen && (
  <div
    className="modal"
    style={{
      display: 'block',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      zIndex: 10000,
    }}
  >
    <div
      className="modal-dialog"
      style={{ maxWidth: '500px', margin: 'auto', marginTop: '100px', top:'50px' }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Upload Excel File</h5>
        </div>

        <div className="modal-body">
          {/* Dropdown for selecting Shenet Type */}
          
            <div className="form-group">
              <label htmlFor="shenetType">Select Shenet Type</label>
              <select
                id="shenetType"
                className="form-control"
                onChange={(e) => setShenetType(e.target.value)}
                value={shenetType || ''}
                required
              >
                <option value="">Select Type</option>
                {/* <option value="incident">Incident</option> */}
                <option value="mocTickets">MOC Tickets</option>
              </select>
            </div>
       

          {/* Show file input only after selecting a Shenet Type */}
          {shenetType && (
            <div className="form-group">
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                className="form-control mt-3"
                required
                multiple
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn bg-primary"
            onClick={() => setIsModalOpen(false)}
          >
            {
              loader ? (
          <div className="spinner-border spinner-border-sm text-white" role="status"></div>

              ) : (
                <>
                
                Close
                </>
              )
            }
          </button>

          <button
            type="button"
            className="btn bg-danger"
            onClick={downloadPdf}
          >
            
                  {
              loader ? (
          <div className="spinner-border spinner-border-sm text-white" role="status"></div>

              ) : (
                <>
                
                Download PDF
                </>
              )
            }
          </button>
        </div>
      </div>
    </div>
  </div>
)}



    </>
  );
};

export default PdfRenderer;
